import React, { useState, useEffect } from "react";
import authStorage from "../../utils/authStorage";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, PaymentElement } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import axios from "axios";
import { BASE_URL, STRIPE_PUBLISHABLE_KEY } from "../../config";

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
// const stripePromise = loadStripe("pk_test_51PMPyEB07cuuAetUU68fWsSaL36tDEReI25kWVbN3n9X0edl56vlOXV9f0jlFVrmkTzp6b4Mkg471EaL5IEnB9we00t5BegabV");

const StripeMobilePayment = ({ setPaymentPage, setPaymentPageLoaded, paymentType ,emails,discount,subId}) => {
    const appearance = {
        theme: 'stripe',
        variables: {
            colorPrimary: '#26455A',
            colorBackground: '#1b425c',
            colorText: '#F2F2F2',
            colorDanger: '#df1b41',
            fontFamily: 'Ideal Sans, system-ui, sans-serif',
            spacingUnit: '3.5px',
            borderRadius: '0px',
            border: '1px solid #ffffff38'
        }
    };
    // const [coupenData,setCoupenData]=useState({})
    const [clientSecret, setClientSecret] = useState('');
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [options, setOptions] = useState({});
   
    useEffect(() => {
        // getDeviceStatus();
        if (!paymentType) {
            return;
        }
        // const storedCoupon = authStorage.getItem('coupon'); const { amount, discountPercent, email } = req.body;

      authStorage.setItem("subId",subId);
        setEmail(authStorage.getItem('email'));
        axios({
            url: `${BASE_URL}/auth/create-payment-app-intent`,
            method: "POST",
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            },
            data: { amount: paymentType, discountPercent: discount, email: emails, subId: subId },
        }).then((data) => {
            window.location.href = data?.data?.url;
        });
    }, [paymentType]);

    useEffect(() => {
        if (clientSecret) {
            setOptions({
                appearance,
                clientSecret,
                paymentMethodCreation: 'manual',
                automaticPaymentMethods: {
                    enabled: true,
                },
            });
        }
    }, [clientSecret]);

    return (
        <div role="status">
    <svg aria-hidden="true" class="w-24 h-24 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>
    <span class="sr-only">Processing..</span>
</div>
    );
}

export default StripeMobilePayment;